import api from './../../api/api'

export default {
  upload: async (url, file, onProgress, id) => {
    let formData = new FormData()
    formData.append('file', file)
    return api.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: progressEvent => {
        onProgress(parseInt(
          Math.round((progressEvent.loaded * 85) / progressEvent.total)
        ), id)
      }
    })
  }

}
